import { StockItemTransaction } from './stock-item-transaction';

export interface StockItemDetails {
  id: string;
  stockNo: string;
  dateCreated: Date;
  productId: string;
  productKey: string;
  productDescription: string;
  productOldCode: string;
  productTypeDescription: string;
  imperialStock: boolean;
  balance: number;
  pricePerUnit: number;
  warehouseId: string;
  locationId: string;
  gradeId: string;
  makeUpId: string;
  batchNo: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  qtyIntoStock: number;
  dateIntoStock: Date;
  intoStockNarrative: string;
  totalAllocated: number;
  issued: number;
  purchaseOrderNo: string;
  supplier: string;
  orderDate: Date;
  purchasePrice: number;
  purchaseInvoiceNo: number;
  purchaseInvoiceDate: Date;
  purchaseInvoiceQty: number;
  purchaseInvoiceValue: number;
  purchaseInvoicePrice: number;
  purchaseCurrencyCode: string;
  comments: string;
  balanceImperial: number;
  totalAllocatedImperial: number;
  issuedImperial: number;
  qtyIntoStockImperial: number;
  unitOfMeasure: string;
  currencyCode: string;
  stockAdjustmentReasonId: string;
  adjustmentQuantity: number;
  splitStock: boolean;
  holdStockAtProductLevel: boolean;
  externalNo: string;
  stockItemTransactions: StockItemTransaction[];
}
